/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

export type GetModulesParams = {
  course_id?: string | null;
  state?: string | null;
  page?: number;
  pageSize?: number;
  sort?: string;
  filter?: string;
};
